import { computed } from 'vue';
import {useAuthStore} from "@/store/auth.module";
import { decodeJWT } from '@/utils/jwt';
import {USER_ROLE} from "@/common/common-enum";

export function useAuthInfo() {
  const authStore = useAuthStore();

  const currentUser = computed(() => authStore.status.user);
  const isArtist = computed(() => currentUser.value?.roleType === USER_ROLE.ARTIST);
  const isArtistBeforeProfile = computed(() => currentUser.value?.roleType === USER_ROLE.ARTIST_BEFORE_PROFILE);
  const isArtistPending = computed(() => currentUser.value?.roleType?.startsWith(USER_ROLE.ARTIST_PENDING));
  const artistUserAccountId = computed(() => {
    const token = currentUser.value?.accessToken;
    return token ? decodeJWT(token).sub : null;
  });

  return {
    currentUser,
    isArtist,
    isArtistBeforeProfile,
    isArtistPending,
    artistUserAccountId,
  };
}
